import { supabase } from '@/lib/supabase';

export async function getMyPrivateNote({
  projectId,
}: {
  projectId: number;
}): Promise<string> {
  const { data, error } = await supabase
    .from('project_notes')
    .select('content')
    .eq('project_id', projectId)
    .eq('note_type', 'private')
    .maybeSingle();
  if (error) throw error;
  return data?.content ?? '';
}

export async function upsertMyPrivateNote({
  projectId,
  content,
  profileId,
}: {
  projectId: number;
  content: string;
  profileId: string;
}): Promise<void> {
  const { error } = await supabase.from('project_notes').upsert(
    {
      project_id: projectId,
      note_type: 'private',
      content,
      profile_id: profileId,
    },
    { onConflict: 'project_id,note_type,profile_id' },
  );
  if (error) throw error;
}
